/* import __COLOCATED_TEMPLATE__ from './savings-account-disclosure.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { AGREEMENTS_URLS } from '@banking/ui/utils/constants';
let SavingsAccountDisclosure = (_class = class SavingsAccountDisclosure extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get isSubmitEnabled() {
    return this.args.disclosureAgreed;
  }
  get depositAccountLink() {
    return AGREEMENTS_URLS.depositAccountLink;
  }
  get privacyPolicyLink() {
    return AGREEMENTS_URLS.privacyPolicyLink;
  }
  get eSignAgreementLink() {
    return AGREEMENTS_URLS.eSignAgreementLink;
  }
  get termsOfServiceLink() {
    return AGREEMENTS_URLS.termsOfServiceLink;
  }
  get maskedTaxId() {
    return this.args.taxIdLast4 ? `••• •• ${this.args.taxIdLast4}` : '••• •• ••••';
  }
  handleBackupWithholdingClick(subjectToWithholding) {
    this.args.onBackupWithholdingToggle(subjectToWithholding);
  }
  handleDisclosureCheckboxChange(event) {
    this.args.onDisclosureAgreementChange(event.type === 'marketRowSelected');
  }
  handleSubmit(event) {
    event.preventDefault();
    if (this.isSubmitEnabled) {
      this.args.onSubmit();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleBackupWithholdingClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleBackupWithholdingClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDisclosureCheckboxChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDisclosureCheckboxChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSubmit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSubmit"), _class.prototype), _class);
export { SavingsAccountDisclosure as default };